import { useCallback } from 'react'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'

const PAGE_TYPE = 'homepage'

const useSubscriptionPromoTracking = () => {
  const { trackEvent } = useTracker()

  const trackImpression = useCallback(() => {
    trackEvent(SubscriptionEvents.PROMO_BANNER_IMPRESSION, { page_type: PAGE_TYPE })
  }, [trackEvent])

  const trackCtaClick = useCallback(() => {
    trackEvent(SubscriptionEvents.PROMO_BANNER_CTA_CLICK, { page_type: PAGE_TYPE })
  }, [trackEvent])

  return {
    trackImpression,
    trackCtaClick,
  }
}

export default useSubscriptionPromoTracking
